import { Container } from 'reactstrap';
import { IdentificationTypesOptionsLoader } from './parts/IdentificationTypesOptionsLoader';
import { AttendancesView } from './parts/AttendancesView';

export function TeacherAttendance() {
  return (
    <Container fluid>
      <IdentificationTypesOptionsLoader>
        {({ data }) => <AttendancesView identificationTypes={data} />}
      </IdentificationTypesOptionsLoader>
    </Container>
  );
}
